import React, { useState, useEffect } from "react";
import { getTweets } from "../../services/tweetService";
import { LinkedinShareButton, LinkedinIcon, ThreadsIcon } from "react-share";

const RecentlyGenerated = ({ collapsed }) => {
  const [items, setItems] = useState([]);
  const [error, setError] = useState(null);

  const ThreadsShareButton = ({ url, title, children }) => {
    const shareUrl = `https://www.threads.net/intent/post?text=${encodeURIComponent(
      `${title}\n\n${url}`,
    )}`;

    return (
      <a
        href={shareUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="share-button"
      >
        {children}
      </a>
    );
  };

  // const [tokens, setTokens] = useState(null);
  // const [tweetText, setTweetText] = useState("");

  // const [checkToken, setCheckToken] = useState("Login");

  // useEffect(() => {
  //   const checkToken = async () => {
  //     try {
  //       const response = await validateAccess();
  //       console.log(response.data);
  //       setCheckToken(response.data.data);
  //     } catch (err) {
  //       setError(err.message);
  //     }
  //   };
  //   checkToken();
  // }, []);

  // const [twittertokens, setTwitterTokens] = useState(null);

  // Handle OAuth callback
  // useEffect(() => {
  //   const params = new URLSearchParams(window.location.search);
  //   if (params.has("oauth_token")) {
  //     handleCallback().then(setTwitterTokens);
  //   }
  // }, []);

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   await postTweet(tweetText, tokens);
  //   alert("Tweet posted!");
  // };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getTweets();
        // console.log(response);
        setItems(response.data.data);
        setError(null);
      } catch (err) {
        setError(err.message);
        setItems([]);
      }
    };

    fetchData();
  }, []);
  return (
    <div
      className={`transition-all duration-300 ${
        collapsed ? "lg:ml-16" : "lg:ml-72"
      }`}
    >
      <h1>Recently Generated</h1>
      <ul role="list" className="divide-y divide-gray-100">
        {items !== null &&
          items.map((item) => (
            <li
              key={item.tweet_id}
              className="flex items-center justify-between gap-x-6 py-5"
            >
              <div className="min-w-0">
                <div className="flex items-start gap-x-3">
                  <p className="text-sm/6 font-semibold text-gray-900">
                    {item.text}
                  </p>
                </div>
                <div className="mt-1 flex items-center gap-x-2 text-xs/5 text-gray-500">
                  <p className="whitespace-nowrap">
                    Created on{" "}
                    <time dateTime={item.generation_time}>
                      {item.generation_time}
                    </time>
                  </p>
                </div>
              </div>
              <div className="flex flex-none items-center gap-x-4">
                <a
                  href="test.com"
                  className="hidden rounded-md bg-white px-2.5 py-1.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:block"
                >
                  Edit
                </a>
                <ThreadsShareButton url="" title={item.text}>
                  <button
                    className="
        bg-black hover:bg-gray-900 text-white 
        px-4 py-2 rounded-lg 
        flex items-center gap-2
        transition-colors duration-200
        focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-opacity-50
        shadow-sm hover:shadow-md
      "
                  >
                    <ThreadsIcon size={20} round />
                  </button>
                </ThreadsShareButton>
                <LinkedinShareButton url="" title={item.text}>
                  <button className="bg-[#0A66C2] text-white px-4 py-2 rounded-md flex items-center gap-2">
                    <LinkedinIcon size={20} round />
                  </button>
                </LinkedinShareButton>
              </div>
            </li>
          ))}
      </ul>
    </div>
  );
};
export default RecentlyGenerated;
